import { render, staticRenderFns } from "./inventoryForm.vue?vue&type=template&id=c8c4eb80&"
import script from "./inventoryForm.vue?vue&type=script&lang=ts&"
export * from "./inventoryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports